import { flattenDeep } from "lodash";
import { ITreeItem } from "../interface/tree-item";

export const flatOptions = (options: Array<ITreeItem>) =>
    flattenDeep(
        options.map(({ id, name, children }) =>
            children
                ? [
                      ...(children.map((child) => ({
                          ...child,
                          parentId: id,
                      })) ?? []),
                  ]
                : [{ id, name }],
        ),
    );
